module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "floating-menu"
  }, [_c('div', {
    staticClass: "ui primary button",
    on: {
      "click": _vm.tutorial
    }
  }, [_vm._v("Tutorial")]), _c('div', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#attribution'),
      expression: "'#attribution'"
    }],
    staticClass: "ui basic button",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("About")]), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "color-scale-container"
  }, [_c('div', {
    staticClass: "scale-label"
  }, [_vm._v("High (1.0)")]), _c('div', {
    staticClass: "scale-bar"
  }), _c('div', {
    staticClass: "scale-label"
  }, [_vm._v("Low (0.0)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58962b26","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MyMenu.vue
// module id = 252
// module chunks = 1